import { render, staticRenderFns } from "./AvoirList.vue?vue&type=template&id=3ace5db6&scoped=true"
import script from "./AvoirList.vue?vue&type=script&lang=js"
export * from "./AvoirList.vue?vue&type=script&lang=js"
import style0 from "./AvoirList.vue?vue&type=style&index=0&id=3ace5db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace5db6",
  null
  
)

export default component.exports